import { Module } from "tabulator-tables";

/**
 * Fixes horizontal scroll position issue in Tabulator upon data reload
 * Background: https://github.com/olifolkerd/tabulator/issues/4494
 */
class ScrollPositionModule extends Module {
  static moduleName = "scrollPosition";
  static moduleInitOrder = 1;
  lastScrollPosition = 0;

  initialize() {
    const holder = this.table.element.querySelector(".tabulator-tableholder");

    holder.addEventListener("scroll", (event) => {
      if (event.target.scrollLeft > 0) this.lastScrollPosition = event.target.scrollLeft;
    });

    this.table.on("renderComplete", () => {
      holder.scrollLeft = this.lastScrollPosition;
    });
  }
}

export { ScrollPositionModule };
